import { render, staticRenderFns } from "./CourseStartPage.vue?vue&type=template&id=1caed97b"
import script from "./CourseStartPage.vue?vue&type=script&lang=js"
export * from "./CourseStartPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports